import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { DateTime } from 'luxon';
import {
  bodySentence,
  isMultiplesDays,
  isToday,
  isUnderWay,
  pastOrFuture, relativeTime,
  SENTENCE_PLURALISATION,
  SENTENCE_TENSE,
} from '@utils/relativeTimeUtils';

export enum EventTimeContext {
  SUBSCRIPTION = 'eventSubscriptionTime_',
  DESCRIPTION = 'eventDescriptionTime_'
}

interface EventTimeSentenceProps {
  startDate: String,
  endDate: String,
  context: EventTimeContext,
  extraVars?: {[key: string]: any}
}

const EventTimeSentence = ({ startDate, endDate, context, extraVars }: EventTimeSentenceProps) => {
  const router = useRouter();
  const { t } = useTranslation();

  const startDateLuxon = DateTime.fromISO(startDate);
  const endDateLuxon = DateTime.fromISO(endDate);
  const isEventMultiplesDays = isMultiplesDays(startDateLuxon, endDateLuxon);
  const isEventUnderWay = isEventMultiplesDays ? isUnderWay(startDateLuxon, endDateLuxon) : isToday(startDateLuxon);
  const sentenceTense = isEventUnderWay ? SENTENCE_TENSE.CURRENT : pastOrFuture(startDate);
  const sentencePluralisation = isEventMultiplesDays ? SENTENCE_PLURALISATION.PLURAL : SENTENCE_PLURALISATION.SINGULAR;
  const relativeDate = sentenceTense === SENTENCE_TENSE.FUTURE ? startDateLuxon.startOf('day') : endDateLuxon.startOf('day');
  // console.log('[DEBUG] Sentence translation key:', `${context}${sentenceTense}${sentencePluralisation}Sentence`);

  return (
    <div>
      {bodySentence(
        startDate,
        endDate,
        router.locale,
        context,
        extraVars
      )[sentenceTense][sentencePluralisation]}
      {` (${relativeTime(relativeDate, sentenceTense, t, context)}).`}
    </div>
  );
};

export default EventTimeSentence;
